<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
      <v-container grid-list-md fluid>
        <v-alert
          :value="alert"
          dismissible
          :type="alertType"
        >
          {{ alertMessage }}
        </v-alert>
        <v-layout wrap>
          <v-flex xs12 sm6 md11>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="presearch"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              />
            </v-card-title>
          </v-flex>
          <v-flex xs12 sm6 md1 class="pt-4">
            <v-btn color="primary" dark @click.prevent="agregar_vehiculo()"
              v-show="add_btn === true" :disabled="!add_btn">
              Agregar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table
        :headers="headers"
        :items="vehiculos"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :loading="is_loading"
        :rows-per-page-items="[5,10,25,50]"
        disable-initial-sort
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.marca }}</td>
            <td class="text-xs-left">{{ props.item.modelo }}</td>
            <td class="text-xs-left">{{ props.item.anio }}</td>
            <td class="text-xs-left">{{ props.item.color }}</td>
            <td class="text-xs-left">{{ props.item.placas }}</td>
            <td class="text-xs-left">{{ props.item.num_tag }}</td>
            <td class="text-xs-left">{{ props.item.viviendas }}</td>
            <td class="text-xs-left">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon @click.prevent="show_vehicle_info(props.item.id)" class="mr-2" small
                    v-on="on" v-show="view_btn === true" :disabled="!view_btn">
                    visibility
                  </v-icon>
                </template>
                <span>Detalles del Vehículo</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon @click.prevent="edit_vehicle(props.item.id)" class="mr-2" small
                    v-on="on" v-show="edit_btn === true" :disabled="!edit_btn">
                    edit
                  </v-icon>
                </template>
                <span>Editar Vehículo</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </template>
<script>
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    totalItems: 0,
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    valid: true,
    add_btn: false,
    view_btn: false,
    edit_btn: false,
    vehiculo_info: {},
    vehiculos: [],
    headers: [
      { text: 'id', value: 'id', sortable: false },
      { text: 'Marca', value: 'marca', sortable: true },
      { text: 'Modelo', value: 'modelo', sortable: true },
      { text: 'Año', value: 'anio', sortable: true },
      { text: 'Color', value: 'color', sortable: true },
      { text: 'Placas', value: 'placas', sortable: true },
      { text: 'Número de Tag', value: 'num_tag', sortable: true },
      { text: 'Vivienda', value: 'viviendas', sortable: false },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['listadoVehiculos/is_loading'];
    },
    vehiculo_submited() {
      return this.$store.getters['listadoVehiculos/vehiculo_submited'];
    },
    vehiculo_processing() {
      return this.$store.getters['listadoVehiculos/vehiculo_processing'];
    },
    alertType() {
      return this.$store.getters['capturaVehiculos/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaVehiculos/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaVehiculos/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['capturaVehiculos/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaVehiculos/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaVehiculos/alertDialog'];
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.search !== '' && this.search != null) {
          this.getDataFromApi()
            .then((data) => {
              this.vehiculos = data.vehiculos;
              this.totalItems = data.total;
            });
        }
      },
      deep: true,
    },
    search(val) {
      if (val === '') {
        this.vehiculos = [];
        this.totalItems = 0;
      } else {
        this.getDataFromApi()
          .then((data) => {
            this.vehiculos = data.vehiculos;
            this.totalItems = data.total;
          });
      }
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
  methods: {
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    agregar_vehiculo() {
      this.$router.push({ name: 'agregar_vehiculo' });
    },
    edit_vehicle(vehiculoId) {
      this.$router.push({ name: 'editar_vehiculo', params: { id: vehiculoId } });
    },
    show_vehicle_info(vehiculoId) {
      this.$router.push({ name: 'detalles_vehiculo', params: { id: vehiculoId } });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, page, rowsPerPage } = this.pagination;
        let { descending } = this.pagination;
        if (descending === null) {
          descending = false;
        }
        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('listadoVehiculos/fetchVehiculos', formdata)
          .then((data) => {
            console.log(data);
            this.loading = false;
            const { vehiculos, total } = data;
            this.$store.commit('listadoVehiculos/fetchedVehiculos');
            resolve({
              vehiculos,
              total,
            });
          });
      });
    },
  },
  created() {
    this.user_login_role = getJWTData().user_claims.role;
    if (['admin', 'admin_eko', 'censo_residentes', 'atencion_residentes', 'avisos', 'censo_domesticos', 'censo_mascotas', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
      if (['admin', 'admin_eko', 'censo_residentes'].includes(this.user_login_role)) {
        this.add_btn = true;
        this.view_btn = true;
        this.edit_btn = true;
      } else if (['censo_domesticos', 'censo_mascotas', 'atencion_residentes', 'avisos', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
        this.view_btn = true;
      }
    }
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  mounted() {

  },
};
</script>
